/** Supported UI locales. Add new locales here — both SiteHeader and LanguageMenu import from here. */
export const SUPPORTED_LOCALES = [
  { code: 'zh-TW', label: '繁體中文' },
  { code: 'en', label: 'English' },
] as const;

export type SupportedLocale = typeof SUPPORTED_LOCALES[number]['code'];

